import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

import { stylePropType } from 'utils/propTypes';
import generatePictureSourceData from 'client/utils/generatePictureSourceData';

export default function ResponsiveBgImage({ src = '', style }) {
    const sourceDatas = useMemo(() => generatePictureSourceData(src), [src]);
    const mediaStyles = sourceDatas.reduceRight(
        (str, data) => (str += `@media ${data.media} { background-image: url(${data.srcSet});} `),
        ''
    );
    return (
        <div
            css={[
                containerStyle,
                css(`background-image: url(${src});`),
                css(mediaStyles),
                css(style)
            ]}
        />
    );
}

ResponsiveBgImage.propTypes = {
    src: PropTypes.string,
    style: stylePropType
};

const containerStyle = css`
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
`;
